import React from 'react';
import PropTypes from 'prop-types';
import PrismButton from '../button/prismButton';
import PrismIcon from '../icon/prismIcon';

import { SORT_COLUMN_PROP_TYPES, SORT_DIRECTION_PROP_TYPES } from './constants';
import { getSortGlyph } from './utils';

class PrismSortToggle extends React.PureComponent {
    static propTypes = {
        sortColumns: PropTypes.arrayOf(SORT_COLUMN_PROP_TYPES).isRequired,
        sortBy: PropTypes.string,
        sortDirection: SORT_DIRECTION_PROP_TYPES.isRequired,
        onToggle: PropTypes.func.isRequired
    };

    renderToggleButton = ({ sortColumns, sortBy, sortDirection, onToggle }) => {
        const sortColumn = sortBy
            && sortColumns.find(column => column.field == sortBy);
        const glyph = getSortGlyph(sortDirection)
            || 'sort';

        return (
            <PrismButton
                className='prism-sort__toggle-button'
                actionLink={true}
                onClick={onToggle}
            >
                {(sortColumn && sortColumn.name) || 'Select'}
                <PrismIcon
                    className='prism-sort__toggle-button-icon'
                    iconClassName='btn-icon__right'
                    glyph={glyph}
                />
            </PrismButton>
        );
    }

    render() {
        return (
            <div className='prism-sort__toggle'>
                <span className='prism-sort__toggle-label'>
                    Sort by
                </span>
                {this.renderToggleButton(this.props)}
            </div>
        );
    }
}

export default PrismSortToggle;
